import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import {
  PageContainer,
  HeroImageSection,
  HeroImageWrap,
  HeroImage,
  MainSection,
  PageTitle,
  PageParagraph,
} from '../SimplePage/SimplePageElements';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=900&q=80';

const Testimonials = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PageContainer>
        <HeroImageSection>
          <HeroImageWrap>
            <HeroImage src={HERO_IMAGE} alt="Client partnership and success" />
          </HeroImageWrap>
        </HeroImageSection>
        <MainSection>
          <Link to="/" style={{ color: '#01bf71', fontWeight: 600, textDecoration: 'none', marginBottom: 32, display: 'inline-block' }}>
            ← Back to Home
          </Link>
          <PageTitle>Testimonials</PageTitle>
          <PageParagraph>
            Hear from businesses we’ve worked with. Testimonials and case studies will be added here soon.
          </PageParagraph>
          <PageParagraph>
            In the meantime, get in touch to learn how we can help grow your business.
          </PageParagraph>
          <PageParagraph>
            <Link to="/getquote" style={{ color: '#01bf71', fontWeight: 600 }}>
              Get a quote →
            </Link>
          </PageParagraph>
        </MainSection>
      </PageContainer>
      <Footer />
    </>
  );
};

export default Testimonials;
